import { render, staticRenderFns } from "./TicketTypes.vue?vue&type=template&id=038cc1c7&scoped=true&"
import script from "./TicketTypes.vue?vue&type=script&lang=ts&"
export * from "./TicketTypes.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/css/helpdesk/ticket-types.css?vue&type=style&index=0&id=038cc1c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038cc1c7",
  null
  
)

export default component.exports